var render = function () {
  var _vm$thirdPartyData, _vm$thirdPartyData2, _vm$thirdPartyData3, _vm$thirdPartyData4, _vm$thirdPartyData5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.isActive
    },
    attrs: {
      "id": "nav-home",
      "role": "tabpanel",
      "aria-labelledby": "nav-home-tab",
      "tabindex": "0"
    }
  }, [!_vm.thirdPartyData ? _c('div', {
    staticClass: "alert-custom alert alert-primary left-brdr shadow"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {}, [_vm._v(" You can also import your data from other platforms into MyWhoosh. ")]), _c('div', {}, [_c('button', {
    staticClass: "btnSuccess",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openThirdPartyModal
    }
  }, [_vm._v(" Import ")])])])]) : ((_vm$thirdPartyData = _vm.thirdPartyData) === null || _vm$thirdPartyData === void 0 ? void 0 : _vm$thirdPartyData.status) === 'submitted' ? _c('div', {
    staticClass: "alert-custom alert alert-review left-brdr shadow"
  }, [_vm._m(0)]) : ((_vm$thirdPartyData2 = _vm.thirdPartyData) === null || _vm$thirdPartyData2 === void 0 ? void 0 : _vm$thirdPartyData2.status) === 'approved' && ((_vm$thirdPartyData3 = _vm.thirdPartyData) === null || _vm$thirdPartyData3 === void 0 ? void 0 : _vm$thirdPartyData3.has_seen) !== 1 ? _c('div', {
    ref: "gotItParent",
    staticClass: "alert-custom alert alert-success left-brdr shadow"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._m(1), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('button', {
    staticClass: "btn btn-success ok float-end",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setUserHasSeen
    }
  }, [_vm._v(" Got It ")])])])]) : ((_vm$thirdPartyData4 = _vm.thirdPartyData) === null || _vm$thirdPartyData4 === void 0 ? void 0 : _vm$thirdPartyData4.status) === 'rejected' ? _c('div', {
    ref: "gotItParentReject",
    staticClass: "alert-custom alert alert-reImport left-brdr shadow"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v(" Sorry! Your application has been declined due to inaccurate information provided. Please try import with correct details. ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('button', {
    staticClass: "btn btnSuccess Import float-end",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openThirdPartyModal
    }
  }, [_vm._v(" re- import ")])])])]) : _vm._e(), _c('ModalThirdPartyImport', {
    ref: "modalThirdParty"
  }), _c('h1', [_vm._v("Progress:")]), _c('div', {
    staticClass: "tbl-wrpr-overAll table-responsive"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('th'), _c('th', [_vm._v("Overall")]), _vm.thirdPartyData && ((_vm$thirdPartyData5 = _vm.thirdPartyData) === null || _vm$thirdPartyData5 === void 0 ? void 0 : _vm$thirdPartyData5.status) === 'approved' ? _c('th', [_vm._v(" Other Platform ")]) : _vm._e(), _c('th', [_vm._v("Yearly (" + _vm._s(_vm.currentYear) + ")")]), _c('th', [_vm._v(" Monthly "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v("(" + _vm._s(_vm.currentMonth.format("MMM")) + ")")])]), _c('th', [_vm._v("Weekly (" + _vm._s(_vm.currentWeek) + ")")])]), _vm._l(_vm.tableData, function (data, key) {
    var _vm$thirdPartyData6, _vm$userData, _vm$userData$data, _vm$userData$data$Pla, _vm$userData$data$Pla2, _vm$userData$data$Pla3, _vm$thirdPartyDistanc, _vm$thirdPartyData7, _vm$userData2, _vm$userData2$data, _vm$userData2$data$Pl, _vm$userData2$data$Pl2, _vm$userData2$data$Pl3, _vm$thirdPartyData8, _parseFloat, _vm$userData3, _vm$userData3$data, _vm$userData3$data$Pl, _vm$userData3$data$Pl2, _vm$thirdPartyTime, _vm$thirdPartyData9, _parseFloat2, _vm$userData4, _vm$userData4$data, _vm$userData4$data$Pl, _vm$userData4$data$Pl2, _vm$thirdPartyData0, _parseFloat3, _vm$userData5, _vm$userData5$data, _vm$userData5$data$Pl, _parseFloat4, _vm$thirdPartyData1, _parseFloat5, _vm$userData6, _vm$userData6$data, _vm$userData6$data$Pl, _vm$thirdPartyData10, _vm$thirdPartyData11;
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(_vm.camelCaseToWords(key)))]), key === 'distance' && _vm.thirdPartyData && ((_vm$thirdPartyData6 = _vm.thirdPartyData) === null || _vm$thirdPartyData6 === void 0 ? void 0 : _vm$thirdPartyData6.status) === 'approved' ? [_c('td', [_vm._v(" " + _vm._s((_vm$userData = _vm.userData) === null || _vm$userData === void 0 ? void 0 : (_vm$userData$data = _vm$userData.data) === null || _vm$userData$data === void 0 ? void 0 : (_vm$userData$data$Pla = _vm$userData$data.PlayerData) === null || _vm$userData$data$Pla === void 0 ? void 0 : (_vm$userData$data$Pla2 = _vm$userData$data$Pla.PlayerPersonalStruct) === null || _vm$userData$data$Pla2 === void 0 ? void 0 : (_vm$userData$data$Pla3 = _vm$userData$data$Pla2.TotalKilometers) === null || _vm$userData$data$Pla3 === void 0 ? void 0 : _vm$userData$data$Pla3.toFixed(2)) + " KM ")]), _c('td', [_vm._v(_vm._s((_vm$thirdPartyDistanc = _vm.thirdPartyDistance) === null || _vm$thirdPartyDistanc === void 0 ? void 0 : _vm$thirdPartyDistanc.toFixed(2)) + " KM")])] : key === 'distance' && ((_vm$thirdPartyData7 = _vm.thirdPartyData) === null || _vm$thirdPartyData7 === void 0 ? void 0 : _vm$thirdPartyData7.status) !== 'approved' ? [_c('td', [_vm._v(" " + _vm._s((_vm$userData2 = _vm.userData) === null || _vm$userData2 === void 0 ? void 0 : (_vm$userData2$data = _vm$userData2.data) === null || _vm$userData2$data === void 0 ? void 0 : (_vm$userData2$data$Pl = _vm$userData2$data.PlayerData) === null || _vm$userData2$data$Pl === void 0 ? void 0 : (_vm$userData2$data$Pl2 = _vm$userData2$data$Pl.PlayerPersonalStruct) === null || _vm$userData2$data$Pl2 === void 0 ? void 0 : (_vm$userData2$data$Pl3 = _vm$userData2$data$Pl2.TotalKilometers) === null || _vm$userData2$data$Pl3 === void 0 ? void 0 : _vm$userData2$data$Pl3.toFixed(2)) + " KM ")])] : _vm._e(), key === 'timeSpend' && _vm.thirdPartyData && ((_vm$thirdPartyData8 = _vm.thirdPartyData) === null || _vm$thirdPartyData8 === void 0 ? void 0 : _vm$thirdPartyData8.status) === 'approved' ? [_c('td', [_vm._v(" " + _vm._s((_parseFloat = parseFloat(((_vm$userData3 = _vm.userData) === null || _vm$userData3 === void 0 ? void 0 : (_vm$userData3$data = _vm$userData3.data) === null || _vm$userData3$data === void 0 ? void 0 : (_vm$userData3$data$Pl = _vm$userData3$data.PlayerData) === null || _vm$userData3$data$Pl === void 0 ? void 0 : (_vm$userData3$data$Pl2 = _vm$userData3$data$Pl.PlayerPersonalStruct) === null || _vm$userData3$data$Pl2 === void 0 ? void 0 : _vm$userData3$data$Pl2.TotalRideTime) / 3600)) === null || _parseFloat === void 0 ? void 0 : _parseFloat.toFixed(2)) + " h ")]), _c('td', [_vm._v(_vm._s((_vm$thirdPartyTime = _vm.thirdPartyTime) === null || _vm$thirdPartyTime === void 0 ? void 0 : _vm$thirdPartyTime.toFixed(2)) + " h")])] : key === 'timeSpend' && ((_vm$thirdPartyData9 = _vm.thirdPartyData) === null || _vm$thirdPartyData9 === void 0 ? void 0 : _vm$thirdPartyData9.status) !== 'approved' ? [_c('td', [_vm._v(" " + _vm._s((_parseFloat2 = parseFloat(((_vm$userData4 = _vm.userData) === null || _vm$userData4 === void 0 ? void 0 : (_vm$userData4$data = _vm$userData4.data) === null || _vm$userData4$data === void 0 ? void 0 : (_vm$userData4$data$Pl = _vm$userData4$data.PlayerData) === null || _vm$userData4$data$Pl === void 0 ? void 0 : (_vm$userData4$data$Pl2 = _vm$userData4$data$Pl.PlayerPersonalStruct) === null || _vm$userData4$data$Pl2 === void 0 ? void 0 : _vm$userData4$data$Pl2.TotalRideTime) / 3600)) === null || _parseFloat2 === void 0 ? void 0 : _parseFloat2.toFixed(2)) + " h ")])] : _vm._e(), key === 'elevation' && _vm.thirdPartyData && ((_vm$thirdPartyData0 = _vm.thirdPartyData) === null || _vm$thirdPartyData0 === void 0 ? void 0 : _vm$thirdPartyData0.status) === 'approved' ? [_c('td', [_vm._v(" " + _vm._s((_parseFloat3 = parseFloat((_vm$userData5 = _vm.userData) === null || _vm$userData5 === void 0 ? void 0 : (_vm$userData5$data = _vm$userData5.data) === null || _vm$userData5$data === void 0 ? void 0 : (_vm$userData5$data$Pl = _vm$userData5$data.PlayerData.PlayerPersonalStruct) === null || _vm$userData5$data$Pl === void 0 ? void 0 : _vm$userData5$data$Pl.TotalElevation)) === null || _parseFloat3 === void 0 ? void 0 : _parseFloat3.toFixed(2)) + " M ")]), _c('td', [_vm._v(" " + _vm._s((_parseFloat4 = parseFloat(_vm.thirdPartyElevation)) === null || _parseFloat4 === void 0 ? void 0 : _parseFloat4.toFixed(2)) + " M ")])] : key === 'elevation' && ((_vm$thirdPartyData1 = _vm.thirdPartyData) === null || _vm$thirdPartyData1 === void 0 ? void 0 : _vm$thirdPartyData1.status) !== 'approved' ? [_c('td', [_vm._v(" " + _vm._s((_parseFloat5 = parseFloat((_vm$userData6 = _vm.userData) === null || _vm$userData6 === void 0 ? void 0 : (_vm$userData6$data = _vm$userData6.data) === null || _vm$userData6$data === void 0 ? void 0 : (_vm$userData6$data$Pl = _vm$userData6$data.PlayerData.PlayerPersonalStruct) === null || _vm$userData6$data$Pl === void 0 ? void 0 : _vm$userData6$data$Pl.TotalElevation)) === null || _parseFloat5 === void 0 ? void 0 : _parseFloat5.toFixed(2)) + " M ")])] : _vm._e(), key === 'races' && _vm.thirdPartyData && ((_vm$thirdPartyData10 = _vm.thirdPartyData) === null || _vm$thirdPartyData10 === void 0 ? void 0 : _vm$thirdPartyData10.status) === 'approved' ? [_c('td', [_vm._v(_vm._s(_vm.totalEvents))]), _c('td', [_vm._v("--")])] : key === 'races' && ((_vm$thirdPartyData11 = _vm.thirdPartyData) === null || _vm$thirdPartyData11 === void 0 ? void 0 : _vm$thirdPartyData11.status) !== 'approved' ? [_c('td', [_vm._v(_vm._s(_vm.totalEvents))])] : _vm._e(), _c('td', [_vm._v(_vm._s(data.year))]), _c('td', [_vm._v(_vm._s(data.month))]), _c('td', [_vm._v(_vm._s(data.week))])], 2);
  })], 2)])]), _c('section', [_c('div', {
    staticClass: "searchMainWrpr-dayWeek my-3"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-8 col-xl-7 col-xxl-7"
  }, [_c('div', {
    staticClass: "select my-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.durationType,
      expression: "durationType"
    }],
    staticClass: "form-select duration-type",
    attrs: {
      "aria-label": "Default select example",
      "name": "duration-type",
      "id": "duration-type"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.durationType = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "week"
    }
  }, [_vm._v("THIS WEEK")]), _c('option', {
    attrs: {
      "value": "month"
    }
  }, [_vm._v("THIS MONTH")]), _c('option', {
    attrs: {
      "value": "year",
      "selected": ""
    }
  }, [_vm._v("THIS YEAR")])])]), _c('div', {
    staticClass: "select my-1 float-end"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.dataType,
      expression: "dataType"
    }],
    staticClass: "data-type",
    attrs: {
      "name": "data-type",
      "id": "data-type"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.dataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "distance",
      "selected": ""
    }
  }, [_vm._v("DISTANCE")]), _c('option', {
    attrs: {
      "value": "elevation"
    }
  }, [_vm._v("ELEVATION")])])])]), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-4 col-xl-5 col-xxl-5"
  })])])]), _c('section', {
    staticClass: "chart-div"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm.isActive ? _c('BarChartGenerator', {
    attrs: {
      "chart-data": _vm.getChartData,
      "chart-options": _vm.getChartOption
    }
  }) : _vm._e()], 1)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._v(" Our team is reviewing your application, we will get back to you soon! "), _c('img', {
    staticClass: "mx-1",
    attrs: {
      "src": "/assets/images/review.png"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v(" Congratulations!, your data has been imported successfully "), _c('img', {
    staticClass: "mx-1",
    attrs: {
      "src": "/assets/images/celeb.png"
    }
  })]);
}]

export { render, staticRenderFns }